// #region Import
import AuthResponse from "../classes/AuthResponse";
import UserEntry from "../classes/UserEntries";
// #endregion
export default class LoginManager {
    // #region Konstanten
    usernameKey = '288a.username';
    // #endregion
    // #region Vars
    _clientID;
    _clientSecret;
    _scopes;
    // #endregion
    // #region Constructor
    constructor() {
        this._clientID = host.config.apiClientID;
        this._clientSecret = host.config.apiClientSecret;
        this._scopes = host.config.apiScopes;
    }
    // #endregion
    // #region Login
    async loginByUsername(userName, password) {
        // #region Username
        host.cookies.setItem(this.usernameKey, userName, 365);
        // #endregion
        // #region Data
        let tData = {
            client_id: this._clientID,
            client_secret: this._clientSecret,
            scope: this._scopes,
            grant_type: "password",
            username: userName,
            password: password
        };
        // #endregion
        return this.sessionLogin(tData, true);
    }
    async connect() {
        // #region Run
        await this.sessionInit(undefined, false);
        // #endregion
    }
    async loginIfHasCoockie() {
        // #region Run
        await this.sessionInit(undefined, false);
        // #endregion
    }
    async logout() {
        // #region Core
        await host.api.post("/system/session/logout");
        // #endregion
        // #region Remove
        await this.sessionInit(undefined, false);
        // #endregion
    }
    // #endregion
    // #region Account
    async setAccount(accountID) {
        try {
            // #region Run
            //Run
            let tResult = await host.api.post("/system/session/account/" + accountID);
            //Handle
            if (tResult.data.userId) {
                //Get
                let tUser = new UserEntry(tResult.data);
                //Session
                host.store.commit("session/setUser", tUser);
                host.store.commit('navigation/load', tUser);
            }
            // #endregion
            // #region Finish
            host.eventBus.emit('refresh');
            // #endregion
        }
        catch (e) {
            host.notification.showError(e);
        }
    }
    // #endregion
    // #region Activate
    activate(data) {
        // #region Core
        return host.api.post("identity/profile/activate", data)
            // #region Succeeded
            .then((e) => {
            return this.sessionInit(undefined, true);
        })
            // #endregion
            // #region Error
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        });
        // #endregion
        // #endregion
    }
    activateByMail(data) {
        // #region Core
        return host.api.post("identity/profile/activate-mail", data)
            // #region Succeeded
            .then((e) => {
            return this.loginByUsername(data.userName, data.password);
        })
            // #endregion
            // #region Error
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        });
        // #endregion
        // #endregion
    }
    // #endregion
    // #region Helper
    getUsername() {
        return host.cookies.getItem(this.usernameKey);
    }
    setUsername(username) {
        return host.cookies.setItem(this.usernameKey, username);
    }
    // #endregion
    // #region Internal
    async sessionLogin(data, isLogin) {
        return await host.api.post("/system/session/login", data)
            // #region Succeeded
            .then((e) => {
            // #region Activate
            if (e.data.action === "activate") {
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_activate",
                    customData: e.data
                });
            }
            // #endregion
            // #region User
            else if (e.data.userId) {
                let tUser = new UserEntry(e.data);
                //Notify        
                if (isLogin) {
                    host.store.commit("session/loggedIn", tUser);
                }
                else {
                    host.store.commit("session/setUser", tUser);
                }
                return new AuthResponse({
                    isSucceded: true,
                    errorMessage: "",
                    token: undefined
                });
            }
            else {
                return new AuthResponse({
                    isSucceded: false,
                    errorMessage: e.data.message,
                });
            }
            // #endregion
        })
            // #endregion
            // #region Error
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        });
        // #endregion
    }
    async sessionInit(auth, isLogin) {
        return host.api.post("/system/session/connect")
            .then((e) => {
            // #region Activate
            if (e.data.action === "activate") {
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_activate",
                    customData: e.data
                });
            }
            // #endregion
            // #region User
            else if (e.data.userId) {
                let tUser = new UserEntry(e.data);
                //Notify        
                if (isLogin) {
                    host.store.commit("session/loggedIn", tUser);
                }
                else {
                    host.store.commit("session/setUser", tUser);
                }
                return new AuthResponse({
                    isSucceded: true,
                    errorMessage: "",
                    token: auth
                });
            }
            // #endregion
            // #region Anonymus
            else {
                //Notify
                host.store.commit("session/anonymous", e.data);
                //Response
                return new AuthResponse({
                    isSucceded: false,
                    errorMessage: "",
                    token: auth
                });
            }
            // #endregion
        })
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorMessage: utils.getAxiosErrorMessage(e)
            });
        });
    }
}
